import { createGlobalStyle, css } from "styled-components";

export default createGlobalStyle` 
${({ theme }) => css`
	html {
		height: 100%;

		body {
			display: flex;
			flex-direction: column;
			height: 100%;
			margin: 0;
			padding: none;
			color: #f3f2f2;
			-webkit-user-select: none;
			-moz-user-select: none;
			-ms-user-select: none;
			user-select: none;

			#root {
				display: flex;
				font-family: "rubik", sans-serif;
				height: 100%;
				justify-content: center;
				padding: none;
			}

			button {
				outline: none;
				border: none;
				font-family: "rubik";
			}

			textarea,
			input {
				font-family: "rubik", sans-serif;
				color: #f3f2f2;
				outline: none;
			}
		}
	}
`}
`;
